import { useState } from 'react'
import { changePassword } from '../api/auth'
import { useSession } from '../store/session'
import { BRAND } from '../brand'

export function ForcePasswordChange() {
  const reload = useSession((s) => s.reload)
  const [current, setCurrent] = useState('')
  const [next, setNext] = useState('')
  const [confirm, setConfirm] = useState('')
  const [err, setErr] = useState('')
  const [busy, setBusy] = useState(false)

  async function submit() {
    setErr('')
    if (next !== confirm) {
      setErr('The new passwords do not match.')
      return
    }
    setBusy(true)
    try {
      await changePassword(current, next)
      await reload() // must_change_password now false → RequireAuth lets the app through
    } catch (e) {
      setErr(e instanceof Error ? e.message : 'Could not change password')
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="auth-wrap">
      <div className="auth-col">
        <div className="auth-brand">
          <div className="mark" />
          <div className="name">{BRAND.name}</div>
          <div className="tag">Console</div>
        </div>
        <div className="auth-card">
          <div>
            <h1>Set a new password</h1>
            <div className="lead">Your account uses a one-time password — choose your own to continue.</div>
          </div>
          <label className="auth-field">
            <span>Current (one-time) password</span>
            <input className="auth-input mono" type="password" value={current} onChange={(e) => setCurrent(e.target.value)} />
          </label>
          <label className="auth-field">
            <span>New password</span>
            <input className="auth-input mono" type="password" value={next} onChange={(e) => setNext(e.target.value)} />
          </label>
          <label className="auth-field">
            <span>Confirm new password</span>
            <input className="auth-input mono" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} />
          </label>
          {err && <div className="auth-error">{err}</div>}
          <button className="btn primary" disabled={busy || !current || !next} onClick={submit}>
            {busy ? 'Saving…' : 'Save and continue'}
          </button>
          <div className="auth-hint">At least 10 characters with a mix of upper, lower, digits and symbols.</div>
        </div>
      </div>
    </div>
  )
}
